///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";

import Modes from "./Modes";
import Truckload from "./Truckload";
import Accordion from "../form-controls/Accordion";
import { mode } from "../../helpers/types";
import LessthanTruckload from "./LessthanTruckload";
import Intermodal from "./Intermodal";
import messages from "../../helpers/messages";

function ModeInformation({
  bid,
  handleModeSelection,
  validationData,
  removeError,
  setModeDetails,
  userDivision,
  disableIMDLBid
}) {
  const modes = bid.modes;

  return (
    <Fragment>
      <Modes
        bid={bid}
        handleModeSelection={handleModeSelection}
        userDivision={userDivision}
        disableIMDLBid={disableIMDLBid}
      />
      {modes.map(modeDetails => (
        <Fragment key={modeDetails.mode}>
          {modeDetails.mode === mode.tl && (
            <Accordion title={messages.truckload.defaultMessage}>
              <Truckload
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                removeError={removeError}
                validationData={validationData.tl}
                shipper={bid.shipper}
                userOrBidDivision={userDivision}
                bidScac={bid.bidScac}
              />
            </Accordion>
          )}
          {modeDetails.mode === mode.imdl && (
            <Accordion title={messages.intermodal.defaultMessage}>
              <Intermodal
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                removeError={removeError}
                validationData={validationData.imdl}
                shipper={bid.shipper}
                bidScac={bid.bidScac}
              />
            </Accordion>
          )}
          {modeDetails.mode === mode.ltl && (
            <Accordion title={messages.lessThanTruckload.defaultMessage}>
              <LessthanTruckload
                modeDetails={modeDetails}
                setModeDetails={setModeDetails}
                removeError={removeError}
                validationData={validationData.ltl}
              />
            </Accordion>
          )}
        </Fragment>
      ))}
    </Fragment>
  );
}

export default ModeInformation;
